module.exports = __webpack_public_path__ + "img/tema-1-2.079fc451.png";